import { useEffect, useState } from "react";
import { toast } from "sonner";
import { BellRing } from "lucide-react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { Section } from "@/components/monitor/shared";

const FIELDS = [
  ["cpu_pct", "CPU sınırı", "%"], ["ram_pct", "RAM sınırı", "%"], ["disk_pct", "Disk kritik seviyesi", "%"],
  ["api_p95_ms", "API yavaşlık sınırı (p95)", "ms"], ["db_ping_ms", "Veritabanı yavaşlık sınırı", "ms"], ["error_rate_pct", "Hata oranı sınırı", "%"],
  ["traffic_spike_x", "Trafik artışı katsayısı (son 1 saat ortalamasına göre)", "x"], ["traffic_min_rpm", "Trafik alarmı için en az istek / dk", ""],
  ["module_p95_ms", "Modül yavaşlık sınırı (p95)", "ms"],
];

export default function AlarmsTab() {
  const [s, setS] = useState(null);
  const [rcpt, setRcpt] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/admin/monitor/settings").then((r) => { setS(r.data); setRcpt(r.data.email_recipients.join(", ")); }); }, []);
  if (!s) return <div className="text-sm text-slate-500">Yükleniyor...</div>;
  const save = async () => {
    setBusy(true);
    try {
      const body = Object.fromEntries(FIELDS.map(([k]) => [k, Number(s[k])]));
      const r = await api.put("/admin/monitor/settings", { ...body, email_enabled: s.email_enabled, email_recipients: rcpt.split(/[,\s]+/).filter(Boolean) });
      setS(r.data); toast.success("Alarm ayarları kaydedildi");
    } catch (e) { toast.error(typeof e.response?.data?.detail === "string" ? e.response.data.detail : "Geçersiz değer veya e-posta adresi"); }
    setBusy(false);
  };
  const test = async () => {
    setBusy(true);
    try {
      const r = await api.post("/admin/monitor/test-alarm");
      const mails = r.data.emails || [];
      toast.success(`Test alarmı oluşturuldu: ${r.data.notifications} panel bildirimi${mails.length ? `, ${mails.filter((m) => m.ok).length}/${mails.length} e-posta gönderildi` : ""}`);
    } catch { toast.error("Test alarmı başarısız"); }
    setBusy(false);
  };
  return (
    <div className="space-y-5" data-testid="monitor-alarms">
      <Section title="Alarm eşikleri" testId="alarm-thresholds">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {FIELDS.map(([k, label, unit]) => (
            <label key={k} className="block">
              <span className="text-xs font-semibold text-slate-600">{label}</span>
              <div className="flex items-center gap-2 mt-1"><Input data-testid={`alarm-${k}`} type="number" value={s[k]} onChange={(e) => setS({ ...s, [k]: e.target.value })} /><span className="text-xs text-slate-500 w-6">{unit}</span></div>
            </label>
          ))}
        </div>
        <p className="text-[11px] text-slate-500 mt-3">CPU, RAM ve API alarmları sınırın art arda 2 dakika aşılmasıyla açılır; değer normale dönünce otomatik kapanır ve bitiş zamanı kaydedilir.</p>
      </Section>
      <Section title="Bildirimler" testId="alarm-notify">
        <div className="space-y-3">
          <div className="text-sm text-slate-600">Tüm alarmlar Super Admin bildirim ziline ve Sistem Hataları listesine düşer.</div>
          <label className="flex items-center gap-3"><Switch data-testid="alarm-email-switch" checked={s.email_enabled} onCheckedChange={(v) => setS({ ...s, email_enabled: v })} disabled={!s.email_available} />
            <span className="text-sm">Kritik alarmlarda e-posta gönder {!s.email_available && <b className="text-red-600">(e-posta altyapısı tanımlı değil)</b>}</span></label>
          <Input data-testid="alarm-email-recipients" value={rcpt} onChange={(e) => setRcpt(e.target.value)} placeholder="ornek@firma.com, ikinci@firma.com (en fazla 5)" />
          <div className="flex flex-wrap gap-2">
            <Button data-testid="alarm-save-btn" disabled={busy} onClick={save}>Kaydet</Button>
            <Button data-testid="alarm-test-btn" variant="outline" disabled={busy} onClick={test}><BellRing className="w-4 h-4 mr-1.5" />Test alarmı gönder</Button>
          </div>
        </div>
      </Section>
    </div>
  );
}
